

import React from 'react';
import { ApolloConsumer } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import { SizeMe } from 'react-sizeme';


import AppSwitcherHeaderComponent from '../components/AppSwitcherHeader';















function AppSwitcherHeader(props) {
  return (
    <ApolloConsumer>
      {(apolloClient) =>
      <SizeMe>
          {({ size: { width } = { width: 0 } }) =>
        <AppSwitcherHeaderComponent
          apolloClient={apolloClient}
          width={width}
          {...props} />}


        </SizeMe>}

    </ApolloConsumer>);

}

export default withRouter(AppSwitcherHeader);